//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheBlockHeader from "@/components/TheBlockHeader.vue";
import CharacteristicsView from "@/components/objects/CharacteristicsView.vue";
import { DesignExtra } from "@/utils/dto/objects.js";
import { getDefaultThemeSettings } from "@/constants/ui.js";
import isEmpty from "lodash/isEmpty.js";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "PropertiesListItem",
  components: { CharacteristicsView, TheBlockHeader },
  provide: {
    source: 'objCharacteristics',
    module: 'props'
  },
  props: {
    label: {
      type: String
    },
    object_in_tooltip: {
      type: String
    },
    properties: {
      type: Array
    },
    limit: {
      type: Number,
      default: 5
    },
    objectLabel: {
      type: String
    },
    enableExport: {
      type: Boolean,
      default: true
    },
    user: {
      type: Object,
      default: () => {}
    },
    design: {
      type: String,
      default: 'props_default'
    },
    designTheme: {
      type: String,
      default: null
    },
    designExtra: {
      type: [Object, DesignExtra],
      default: () => ({})
    },
  },
  data() {
    const design = this.design || 'props_default'
    const defaultTheme = getDefaultThemeSettings(design, 'props', this.$store)?.themes?.[0]
    const isCustomTheme = this.designTheme === 'custom'
    const initialDesignExtra = (!isCustomTheme || isEmpty(this.designExtra))
      ? new DesignExtra(defaultTheme || {})
      : this.designExtra
    return {
      showFullCharacteristics: false,
      currentTemplate: null,
      currentDesign: design,
      currentTheme: this.designTheme || defaultTheme?.theme || design,
      currentDesignExtra: initialDesignExtra
    }
  },
  computed: {
    propertiesDefault() {
      return this.properties.filter(x => x.template.ranging !== "date_event")
    },
    propertiesByDates() {
      return this.properties.filter(x => x.template.ranging === "date_event")
    },
    joinedProps() {
      const properties = [
        ...this.propertiesByDates.map(({ ...x }, index) => {
          x.is_last_event = this.propertiesByDates.length - 1 === index
          return x
        }),
        ...this.propertiesDefault
      ]

      if (!this.showFullCharacteristics) {
        if (!properties.filter(x => x.is_short).length) return properties.slice(0, this.limit)
        return properties.filter(x => x.is_short).slice(0, this.limit)
      }
      return properties
    },
    isShowedDetailCharacteristicsButton() {
      const shorted = this.properties.filter(x => x.is_short)
      if (shorted.length) {
        return !(this.properties.length === shorted.length && shorted.length <= this.limit)
      } else {
        return this.properties.length > this.limit
      }
    },
    listInfo() {
      return {
        label: this.label,
        subLabel: this.sublabel || "",
        icon: this.icon,
        vistat_object: this.object_in_tooltip,
        object_label: this.objectLabel,
        id: this.id || uuidv4(),
      }
    },
    firstBlockTitleColor() {
      return this.currentDesignExtra?.first_block?.title_color ?? 'rgba(0, 0, 0, 0.65)'
    },
    firstBlockBg() {
      return this.currentDesignExtra?.first_block?.bg_color ?? null;
    },
    firstBlockBgGradientEnabled() {
      return this.currentDesignExtra?.first_block?.gradient_enabled ?? null;
    },
    firstBlockBgGradientDirection() {
      return this.currentDesignExtra?.first_block?.gradient_direction ?? null;
    },
    firstBlockBgGradientShadowDirection() {
      return this.currentDesignExtra?.first_block?.gradient_shadow_direction ?? null;
    },
    firstBlockBorderColor() {
      return this.currentDesignExtra?.first_block?.border_color ?? null;
    },
    firstBlockStyles() {
      if (this.currentDesign === 'props_default') {
        return { borderRadius: 0, borderBottom: `1px dashed ${this.firstBlockBorderColor}` };
      }

      return {}
    },
  },
  methods: {
    onDesignChange(nextDesign) {
      this.currentDesign = nextDesign
      const defaultTheme = getDefaultThemeSettings(nextDesign, 'props', this.$store)?.themes?.[0]
      this.currentTheme = defaultTheme?.theme || nextDesign
      this.currentDesignExtra = new DesignExtra(defaultTheme || {})
    },
    onThemeChange(nextTheme) {
      this.currentTheme = nextTheme
      const themes = getDefaultThemeSettings(this.currentDesign, 'props', this.$store)?.themes || []
      const themeSettings = themes.find(x => x.theme === nextTheme)
      this.currentDesignExtra = new DesignExtra(themeSettings || themes[0] || {})
    },
  },
}
